module.exports = __webpack_public_path__ + "img/certTJ2.9d97a0b4.jpg";